import { useQuery } from "@tanstack/react-query";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { AppShell, Button, EmptyState } from "@plataforma/design-system";
import type { Invoice } from "@plataforma/shared";
import { LoginPage } from "../features/auth/LoginPage";
import { api } from "../lib/api";
import { useAuth } from "./auth";
import { useAppConfig } from "./config";
import { enabledFeatures } from "./features";

export function App() {
  const { config, has } = useAppConfig();
  const { user, loading, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const features = enabledFeatures(config);
  // Contador de notas pendentes no menu; só existe quando a aplicação tem a funcionalidade.
  const pending = useQuery({ queryKey: ["invoices", { status: "pending" }], enabled: Boolean(user) && has("invoices"), queryFn: async () => (await api.get<{ invoices: Invoice[] }>("/invoices?status=pending")).invoices.length });

  if (loading) return <EmptyState>Carregando…</EmptyState>;
  if (!user) return <LoginPage />;
  const home = features[0]?.path ?? "/";

  return (
    <AppShell
      layout={config.layout}
      brand={{ name: config.shortName === config.name ? config.name : config.name, tagline: config.branding.tagline, monogram: config.branding.monogram, logoUrl: config.branding.logoUrl }}
      nav={features.map((feature) => ({
        key: feature.key,
        label: feature.label(config),
        icon: feature.icon,
        badge: feature.key === "invoices" && pending.data ? pending.data : undefined,
        current: location.pathname === feature.path || location.pathname.startsWith(`${feature.path}/`),
        onSelect: () => navigate(feature.path),
      }))}
      user={<><span><strong>{user.name}</strong>{user.roleLabel ? <span className="ds-muted" style={{ display: "block" }}>{user.roleLabel}</span> : null}</span><Button variant="quiet" onClick={() => void logout()}>Sair</Button></>}
      topbar={<><strong>{config.name}</strong><Button size="small" onClick={() => void logout()}>Sair</Button></>}
    >
      <Routes>
        {features.flatMap((feature) => feature.routes).map((route) => <Route key={route.path} path={route.path} element={route.element} />)}
        <Route path="*" element={features.length ? <Navigate to={home} replace /> : <EmptyState title="Nenhuma funcionalidade habilitada nesta aplicação" />} />
      </Routes>
    </AppShell>
  );
}
